import { fetchUserAttributes } from "aws-amplify/auth";
import { createContext, useContext, useEffect, useState } from "react";
import { setAxiosUser } from "../Services/AxiosInstance";


const UserContext = createContext(null);

export const UserProvider = ({ user, children }) => {
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        async function loadUser() {
            if(!user) return;

            const attributes = await fetchUserAttributes();
            console.log("Attributes", attributes);
            const role = attributes["custom:Role"];
            const therapistId = attributes["custom:TherapistId"];

            const formattedUser = {
                username: user.signInDetails?.loginId,
                role,
                therapistId
            };

            setCurrentUser(formattedUser);
            setAxiosUser(formattedUser);
        }

        loadUser();
    }, [user]);

    return (
        <UserContext.Provider value={currentUser}>
            {children}
        </UserContext.Provider>
    );
};

export const useCurrentUser = () => useContext(UserContext);